import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Kit, Profile } from '../../models/customerOverview';
import { DownloadReportFormPayload, DownloadReportFormResponse } from '../../models/profile';
import { APIError } from '../../helpers/types';

export enum CustomerDetailActionTypes {
  FETCH_KITS_SUCCESS = 'CUSTOMERDETAILS_FETCH_KITS_SUCCESS',
  FETCH_PROFILES_SUCCESS = 'CUSTOMERDETAILS_FETCH_PROFILE_SUCCESS',
  START_FETCHING_KITS = 'CUSTOMERDETAILS_START_FETCHING_KITS',

  ACTION_RESET_CUSTOMER_DETAILS = 'RESET_CUSTOMER_DETAILS',

  ACTION_USER_PROFILE_DOWNLOAD_REPORT_SUBMIT = 'ACTION_USER_PROFILE_DOWNLOAD_REPORT_SUBMIT',
  ACTION_USER_PROFILE_DOWNLOAD_REPORT_SUBMIT_SUCCESS = 'ACTION_USER_PROFILE_SEND_REPORT_SUBMIT_SUCCESS',
  ACTION_USER_PROFILE_DOWNLOAD_REPORT_SUBMIT_ERROR = 'ACTION_USER_PROFILE_DOWNLOAD_REPORT_SUBMIT_ERROR',
}

export interface ActionStartFetchingKits extends Action {
  type: CustomerDetailActionTypes.START_FETCHING_KITS;
}
export interface ActionUserProfileSendReportSubmitSuccess extends Action {
  type: CustomerDetailActionTypes.ACTION_USER_PROFILE_DOWNLOAD_REPORT_SUBMIT_SUCCESS;
  payload: DownloadReportFormResponse;
}
export interface ActionUserProfileDownloadReportSubmitError extends Action {
  type: CustomerDetailActionTypes.ACTION_USER_PROFILE_DOWNLOAD_REPORT_SUBMIT_ERROR;
  error: APIError;
}
export interface ActionDownloadReport extends Action {
  type: CustomerDetailActionTypes.ACTION_USER_PROFILE_DOWNLOAD_REPORT_SUBMIT;
  payload: DownloadReportFormPayload;
}

export interface ActionResetCustomerDetails extends Action {
  type: CustomerDetailActionTypes.ACTION_RESET_CUSTOMER_DETAILS;
}

export interface ActionStartFetchingKits extends Action {
  type: CustomerDetailActionTypes.START_FETCHING_KITS;
}
export interface ActionFetchKitSuccessActions extends Action {
  type: CustomerDetailActionTypes.FETCH_KITS_SUCCESS;
  payload: Kit;
}
export interface ActionFetchProfileSuccessActions extends Action {
  type: CustomerDetailActionTypes.FETCH_PROFILES_SUCCESS;
  payload: Profile;
}

export type CustomerDetailedAction =
  | ActionFetchKitSuccessActions
  | ActionFetchProfileSuccessActions
  | ActionStartFetchingKits
  | ActionResetCustomerDetails
  | ActionDownloadReport
  | ActionUserProfileSendReportSubmitSuccess
  | ActionUserProfileDownloadReportSubmitError
  ;
export type CustomerDetailsThunkDispatch = ThunkDispatch<undefined, undefined, CustomerDetailedAction>;